module.exports = __webpack_public_path__ + "img/HPR.443c6689.svg";